import { Component, Inject, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { from, take } from 'rxjs';
import { APP_CONFIG, AppConfig } from 'src/app/config/app-config';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
})
export class ImprintComponent implements OnInit {
  constructor(
    private readonly navCtrl: NavController,
    @Inject(APP_CONFIG) public readonly appConfig: AppConfig,
    public readonly langService: LanguageService,
  ) {}

  ngOnInit() {
    return;
  }

  onBackButtonClick(): void {
    from(this.navCtrl.pop()) // pop() already makes back navigation
      .pipe(take(1))
      .subscribe((hasHistory) => {
        if (!hasHistory) {
          this.navCtrl.navigateRoot('about');
        }
      });
  }
}
